module.exports = __webpack_public_path__ + "img/logo.72d5d85.png";